import { apiEndpoints } from "core/api/apiEndpoints";
import { httpRequest } from "core/api/httpRequest";

// Get profile details of logged in user
const getProfileDetails = () => {
  return httpRequest(apiEndpoints.getProfileDetails, "get");
};

// Get all dropdown data for profile details
const getDropdownMasterData = () => {
  return httpRequest(apiEndpoints.getDropdownMasterData, "get");
};

// Post profile details of logged in user
const postProfileDetails = (payload: any) => {
  return httpRequest(apiEndpoints.getProfileDetails, "post", payload);
};

// Upload profile picture of logged in user
const uploadProfilePicture = () => {
  return httpRequest(apiEndpoints.uploadProfilePicture, "post");
};

// Get all dropdown data for profile details
const getNotification = (id: string) => {
  const url = {
    url: apiEndpoints.getNotification.url + id,
    isMock: apiEndpoints.getNotification.isMock,
  };
  return httpRequest(url, "get");
};

// To save firebase token (used for iOS devices)
const saveFirebasetoken = (payload: any) => {
  return httpRequest(apiEndpoints.saveFirebaseToken, "post", payload);
};

const postNotification = (payload: any) => {
  return httpRequest(apiEndpoints.postNotification, "post", payload);
};

const logoutUser = (payload: any) => {
  return httpRequest(apiEndpoints.logoutUser, "post", payload);
};

const postMenopauseStage = (payload: any) => {
  return httpRequest(apiEndpoints.postMenopauseStage, "post", payload);
};

// submit contact us
const submitContactUs = (payload: any) => {
  return httpRequest(apiEndpoints.contactUs, "post", payload);
};

// get user token from idhub
const getTokenFromIdhub = (payload: any) => {
  return httpRequest(apiEndpoints.getUserToken, "post", payload);
};

// get user token from idhub
const uploadToS3 = (payload: any, url: string, config: any) => {
  return httpRequest(
    apiEndpoints.getUserToken,
    "put",
    payload,
    {
      status: false,
      url: url,
    },
    config,
  );
};

// To delete account
const deleteUserAccount = () => {
  return httpRequest(apiEndpoints.deleteUserAccount, "post");
};

//to check which register method user used
const checkUserRegisterMethod = (param: any) => {
  return httpRequest(apiEndpoints.checkRegisterMethod, "post", param);
};

//upload profile picture v2
const uploadProfilePictureV2 = (payload: any) => {
  return httpRequest(
    apiEndpoints.uploadProfilePictureV2,
    "postFile",
    payload,
    { status: true, url: "" },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

//send utm source data
const updateUtmSource = (payload?: any) => {
  return httpRequest(apiEndpoints.utmSourceUpdate, "post", payload);
};

//remove picture
const removeProfilePictureV2 = () => {
  return httpRequest(apiEndpoints.deleteProfilePicture, "post");
};
export {
  getProfileDetails,
  getDropdownMasterData,
  postProfileDetails,
  uploadProfilePicture,
  getNotification,
  postNotification,
  saveFirebasetoken,
  logoutUser,
  postMenopauseStage,
  submitContactUs,
  getTokenFromIdhub,
  uploadToS3,
  deleteUserAccount,
  checkUserRegisterMethod,
  uploadProfilePictureV2,
  removeProfilePictureV2,
  updateUtmSource,
};
